export { DynamicInfoModal } from '@/components/common/DynamicInfoModal/DynamicInfoModal';
